import { createSlice } from "@reduxjs/toolkit";
import { updatePublicSettings } from "../ai/aiSlice";

const initialState = null;

export const publicSettingsSlice = createSlice({
	name: "publicSettings",
	initialState,
	reducers: {
		syncPublicSettings: (state, action) => {
			return action.payload;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(updatePublicSettings, (state, action) => {
			return action.payload;
		});
	},
});

export const { syncPublicSettings } = publicSettingsSlice.actions;

export default publicSettingsSlice.reducer;
